<template>
  <router-view />
</template>

<script>
export default {
  name: 'BookingIndex',
}
</script>
